var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","clipped-left":"","clipped-right":"","color":"secondary","dark":""}},[_c('v-col',{attrs:{"cols":"12 d-flex justify-space-between align-center"}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" — Rota Certa Sistemas")]),_c('span',[_vm._v("Versão 2.0.5")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }